import React from "react";
import styles from "./styles.module.css";
import Button from "../button-v1";
import { parseDateSafe } from "../../utils/dateFormatters";

export const NotificationUILayer = ({
  notifications = [],
  filteredNotifications = [],
  activeFilter = "all",
  loading = false,
  unreadCount = 0,
  onFilterChange,
  onMarkAllAsRead,
  onNotificationClick,
}) => {
  return (
    <div className={styles.notificationMenu}>
      <div className={styles.header}>
        <h3 className={styles.title}>Notifications</h3>
        {unreadCount > 0 && (
          <button className={styles.markAllButton} onClick={onMarkAllAsRead}>
            Mark all as read
          </button>
        )}
      </div>

      <div className={styles.filters}>
        <p
          //   variant={activeFilter === "all" ? "default" : "ghost"}
          //   isRound
          //   size="small"
          className={`${styles.filterButton} ${
            activeFilter === "all" ? styles.active : ""
          }`}
          onClick={() => onFilterChange?.("all")}
        >
          All
          {notifications.length > 0 && (
            <span className={styles.badge}>{notifications.length}</span>
          )}
        </p>
        <p
          className={`${styles.filterButton} ${
            activeFilter === "unread" ? styles.active : ""
          }`}
          //   size="small"
          //   variant={activeFilter === "unread" ? "default" : "ghost"}
          //   isRound
          onClick={() => onFilterChange?.("unread")}
        >
          Unread
          {unreadCount > 0 && (
            <span className={styles.badge}>{unreadCount}</span>
          )}
        </p>
        <p
          className={`${styles.filterButton} ${
            activeFilter === "read" ? styles.active : ""
          }`}
          //   size="small"
          //   variant={activeFilter === "read" ? "default" : "ghost"}
          //   isRound
          onClick={() => onFilterChange?.("read")}
        >
          Read
        </p>
      </div>

      <div className={styles.notificationList}>
        {loading ? (
          <div className={styles.emptyState}>
            <p>Loading notifications...</p>
          </div>
        ) : filteredNotifications.length === 0 ? (
          <div className={styles.emptyState}>
            <p>No notifications</p>
          </div>
        ) : (
          filteredNotifications.map((notification) => (
            <div
              key={notification.id}
              className={`${styles.notificationItem} ${
                !notification.is_read ? styles.unread : ""
              }`}
              onClick={() =>

               notification && onNotificationClick?.(notification)

              }
            >
              <div className={styles.notificationContent}>
                <section className={styles.notificationHeader}>
                  <h4 className={styles.notificationTitle}>
                    {notification.title || "Notification"}
                  </h4>
                  <span className={styles.notificationTime}>
                    {notification.created_at
                      ? parseDateSafe(notification.created_at)?.toLocaleString() || ""
                      : ""}
                  </span>
                </section>

                <p className={styles.notificationMessage}>
                  {notification.message || ""}
                </p>
                {/* <span className={styles.notificationTime}>
                  {notification.created_at
                    ? parseDateSafe(notification.created_at)?.toLocaleString() || ""
                    : ""}
                </span> */}
              </div>
              {!notification.is_read && (
                <div className={styles.unreadDot}></div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};
